import { ADD_USER_ERROR } from "../types";

export default function(category, question) {
  return {
    category,
    question,
    type: ADD_USER_ERROR
  };
}
